export const sum = (source, selector) => {
    if (selector) {
        return sum2(source, selector);
    }
    else {
        return sum1(source);
    }
};
const sum1 = async (source) => {
    let total = 0;
    for await (const value of source) {
        total += value;
    }
    return total;
};
const sum2 = async (source, selector) => {
    let total = 0;
    for await (const value of source) {
        total += selector(value);
    }
    return total;
};
